import styled, { DefaultTheme } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import StockStatusColumnComponent from '../regular-old/components-old/stock-status-column';
import CampaignBadgeComponent from '../../../../../../../components/campaign-badge';
import { FontEmphasis, FontWeight } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { HighlightedOfferType } from 'src/areas/product/components/product-highlighted-offer/types';
import { Card as CardComponent } from '@prisjakt/ui/card';
import { Content } from '../styles';

export const PriceColumn = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export interface IOfferCard {
  type: HighlightedOfferType;
}

function getColorFromOfferType(
  type: HighlightedOfferType,
  theme: DefaultTheme
): string {
  switch (type) {
    case HighlightedOfferType.Recommended:
      return theme.colors.positive500;
    case HighlightedOfferType.Cheapest:
      return theme.colors.maybeBlue500;
    case HighlightedOfferType.Fastest:
    default:
      return 'transparent';
  }
}

export const HighlightOfferCardHeader = styled.div`
  text-align: center;
`;

export const HighlightOfferCardTitle = styled(CaptionText).attrs({
  emphasis: FontEmphasis.HIGH,
  weight: FontWeight.NORMAL,
})`
  color: ${props => props.theme.buttons.primary.text};
`;

export const HighlightOfferCard = styled(CardComponent)<IOfferCard>`
  border-radius: 8px;
  background: ${props => getColorFromOfferType(props.type, props.theme)};
  box-shadow: 0 0 0 1px
    ${props => getColorFromOfferType(props.type, props.theme)};
`;

export const HighlightContent = styled(Content)`
  border-radius: 8px;
  background: ${props => props.theme.buttons.category.bg};
`;

export const GoToStoreColumn = styled.div`
  margin: 0 ${layout.spacing.xxSmall};
  align-self: center;
  color: ${props => props.theme.buttons.positive.bg};
  display: flex;
`;

export const StockStatusColumn = styled(StockStatusColumnComponent)`
  margin: 0 ${layout.measurements.spacingSmall};
`;
export const StoreLogoColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacingSmall};
  margin-right: ${layout.measurements.spacingSmall};
  align-items: center;
`;
export const ShippingColumn = styled.div`
  display: flex;
`;

export const CampaignBadge = styled(CampaignBadgeComponent)`
  margin-bottom: 2px;
  margin-right: ${layout.measurements.spacingSmall};
`;

export const StockAndPriceRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-column-gap: ${layout.measurements.spacingSmall};
  align-items: center;
`;

export const EndColumn = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  border-left: 1px solid ${props => props.theme.colors.base200};
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: flex-end;
`;
